import {ChangeDetectionStrategy, Component, OnDestroy} from "@angular/core";
import {FUINavigationService} from "../navigation.service";
import {FUINavLayoutService} from "../../nav-layout/nav-layout.service";
import {FUIChromeActionComponent} from "../../chrome/chrome-actions/chrome-action/chrome-action.component";
import {BehaviorSubject, Subscription} from "rxjs";

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "fui-navigation-chrome-action",
    styleUrls: ["./navigation-chrome-action.component.scss"],
    templateUrl: "./navigation-chrome-action.component.html",
    standalone: false
})
export class FUINavigationChromeActionComponent extends FUIChromeActionComponent implements OnDestroy {

    private subscriptions: Subscription = new Subscription();

    constructor(public navigationService: FUINavigationService,
                public navLayoutService: FUINavLayoutService) {
        super();

        this.subscriptions.add(this.navLayoutService.activeFrame$.subscribe((active) => this.active = active));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    /**
     * Toggle the frame of the page ($navigation) and on mobile
     * toggle both the frame and the overlay
     */
    toggle(): void {
        this.active = !this.active;

        if (this.navigationService.useMobileNav()) {
            this.navLayoutService.toggleFrame(this.active);
            this.navigationService.toggleModal(this.active);
        }
        else {
            this.navLayoutService.toggleFrame(this.active);
        }
    }
}
